export default [
  {
    title: 'Acente İşlemleri',
    icon: 'fad fa-users-class',
    route: 'acente-listele',
    children: [],
  },
];
